const navListData = [
	{ _id: 1, link: "", name: "Home" },
	{ _id: 2, link: "movies", name: "Movies" },
	{ _id: 3, link: "tvShows", name: "TV Shows" },
	{ _id: 4, link: "favorites", name: "Favorites" },
];

export default navListData;
